import { Component, h, Prop, Watch, Event, State, EventEmitter } from '@stencil/core';
import { DropDownModal } from './dropdown-modal';

@Component({
  tag: 'legrandav-dropdown',
  styleUrl: 'legrandav-dropdown.css',
  shadow: true,
})
export class LegrandavDropdown {
  private _dropDownData: DropDownModal[];

  @Prop() dropDownData: DropDownModal[] | string;

  @Prop() width: string;

  @Prop() color: string;

  @State() toggle: boolean = false;

  @State() SelectedValue: { name; value } = null;

  @Prop() label: string;

  @Event() onToggle: EventEmitter;

  @Prop() ariaLabel: string;

  @Watch('data')
  objectDataWatcher(newValue: DropDownModal[] | string) {
    if (typeof newValue === 'string') {
      this._dropDownData = JSON.parse(newValue);
    } else {
      this._dropDownData = newValue;
    }
  }

  // @Listen('keydown')
  // handleKeyDown(ev: KeyboardEvent) {
  //   if (this.toggle == true) {
  //     console.log(ev.key);
  //     if (ev.key == 'ArrowDown') {
  //     }
  //     if (ev.key == 'ArrowUp') {
  //     }
  //   }
  // }

  componentWillLoad() {
    this.objectDataWatcher(this.dropDownData);
  }

  toggleComponent() {
    this.toggle = !this.toggle;
    this.onToggle.emit({ visible: this.toggle });
  }

  handleDropDownSelection(e) {
    this.SelectedValue = {
      value: e.target.id,
      name: e.target.innerText,
    };
    this.toggleComponent();
  }

  render() {
    return (
      <div>
        <button
          class="dropdown-button"
          style={{
            width: this.width,
            backgroundColor: this.color,
          }}
          aria-label={this.ariaLabel}
          onClick={() => this.toggleComponent()}
        >
          {this.SelectedValue != null ? this.SelectedValue['name'] : this.label}
          {this.toggle ? (
            <svg transform="rotate(180)" width="14px" height="18px" viewBox="0 0 14 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
              <g id="Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect width="14" height="18"></rect>
                <path
                  d="M12.0187784,5.32138771 C12.4774933,4.88750173 13.2066434,4.89370691 13.6575897,5.33533425 C14.108536,5.77696159 14.1148721,6.49104363 13.6718306,6.94027894 L7.82652606,12.6647882 C7.37000795,13.1117373 6.62999205,13.1117373 6.17347394,12.6647882 L0.328169447,6.94027894 C-0.114872145,6.49104363 -0.108536027,5.77696159 0.342410275,5.33533425 C0.793356576,4.89370691 1.52250674,4.88750173 1.98122156,5.32138771 L7,10.2364514 L12.0187784,5.32138771 Z"
                  id="🎨-Icon-Style"
                  fill="#1B2D3A"
                ></path>
              </g>
            </svg>
          ) : (
            <svg aria-hidden="true" id="feedback-accordion-svg" width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <rect width="14" height="18"></rect>
                <path
                  d="M12.0187784,5.32138771 C12.4774933,4.88750173 13.2066434,4.89370691 13.6575897,5.33533425 C14.108536,5.77696159 14.1148721,6.49104363 13.6718306,6.94027894 L7.82652606,12.6647882 C7.37000795,13.1117373 6.62999205,13.1117373 6.17347394,12.6647882 L0.328169447,6.94027894 C-0.114872145,6.49104363 -0.108536027,5.77696159 0.342410275,5.33533425 C0.793356576,4.89370691 1.52250674,4.88750173 1.98122156,5.32138771 L7,10.2364514 L12.0187784,5.32138771 Z"
                  fill="#1b2d3a"
                ></path>
              </g>
            </svg>
          )}
        </button>
        <div class={`content-box ${this.toggle ? 'open' : 'close'}`} style={{ width: this.width }}>
          <ul class="dropdown">
            {this._dropDownData.map(x => (
              <li onClick={e => this.handleDropDownSelection(e)} id={x.value} role="options" tabIndex={0}>
                {x.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

{
}
